import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { NotificationRuleFormData } from '@/features/notification-rules/schemas/create-notification-rule.schema.ts';
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form.tsx';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip.tsx';
import { Info } from 'lucide-react';
import { Input } from '@/components/ui/input.tsx';

export function CreateNotificationRuleOtherOptionsForm() {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const form = useFormContext<NotificationRuleFormData>();

  return (
    <div className="space-y-2">
      <h2 className="font-semibold">Other options</h2>

      <FormField
        control={form.control}
        name="cooldownPeriod"
        render={({ field }) => (
          <FormItem>
            <div className="flex gap-2">
              <FormLabel className="required">Cooldown Period (minutes)</FormLabel>
              <TooltipProvider>
                <Tooltip open={tooltipOpen} onOpenChange={setTooltipOpen}>
                  <TooltipTrigger asChild>
                    <button
                      type="button"
                      className="text-muted-foreground hover:text-foreground cursor-help touch-manipulation transition-colors"
                      onClick={(e) => {
                        e.preventDefault();
                        setTooltipOpen(!tooltipOpen);
                      }}
                      onMouseEnter={() => setTooltipOpen(true)}
                      onMouseLeave={() => setTooltipOpen(false)}
                    >
                      <Info size={14} />
                    </button>
                  </TooltipTrigger>
                  <TooltipContent side="top" className="max-w-xs">
                    <p className="text-sm">
                      Minimum time interval between notifications. Prevents spam by ensuring
                      notifications are only sent once per cooldown period, even if conditions
                      are met multiple times.
                    </p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            </div>

            <FormControl>
              <Input
                type="number"
                placeholder="60"
                {...field}
                onChange={(e) => field.onChange(Number(e.target.value))}
              />
            </FormControl>
            <FormDescription>
              Time before the same alert can re-trigger. Range: 1 hour – 1 week (60–10080
              minutes).
            </FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
